import { administratorRoles } from "../config/roles";
import { ListDefinition } from "./listDefinition.types";

const recordRoute = "/event-profile";

/**
 * The event profiles list. Paged by the search endpoint and read on arrival. The
 * ticketing feed creates and removes these, so there is no add or delete.
 */
export const eventProfilesListDefinition: ListDefinition = {
  path: "/event-profiles",
  entityName: "dweventprofile",
  recordRoute,
  title: "Event Profiles",
  allowedRoles: administratorRoles,
  data: "search-paged",
  searchOnLoad: true,
  // Lower case: the repository reads these keys from a case-sensitive dictionary.
  filters: [
    { name: "name", label: "Name", kind: "text", width: "wide" },
    { name: "eventcode", label: "Event Code", kind: "text" },
    { name: "start", label: "Start Date", kind: "date-range" },
    {
      name: "seasonid",
      label: "Season",
      kind: "lookup",
      lookupEntity: "dwseason",
      searchable: true,
      width: "wide",
    },
    {
      name: "fixtureid",
      label: "Fixture",
      kind: "lookup",
      lookupEntity: "dwfixture",
      searchable: true,
      width: "wide",
    },
    {
      name: "typeid",
      label: "Type",
      kind: "lookup",
      lookupEntity: "dwtype",
      searchable: true,
    },
  ],
  filterByStatus: false,
  allowAdd: false,
  allowStatusEdit: false,
  allowDelete: false,
  columns: [
    {
      key: "Name",
      label: "Name",
      width: 300,
      sortable: true,
      link: { to: recordRoute, idKey: "Id", newTab: "button" },
    },
    { key: "eventcode", label: "Event Code", width: 200, sortable: true },
    { key: "description", label: "Description", width: 200, sortable: true },
    {
      key: "start",
      label: "Start",
      width: 200,
      display: "local-datetime",
      sortable: true,
    },
    {
      key: "end",
      label: "End",
      width: 200,
      display: "local-datetime",
      sortable: true,
    },
    {
      key: "seasonidname",
      label: "Season",
      width: 200,
      sortable: true,
      link: { to: "/season", idKey: "seasonid", newTab: "button" },
    },
    {
      key: "fixtureidname",
      label: "Fixture",
      width: 200,
      sortable: true,
      link: { to: "/fixture", idKey: "fixtureid", newTab: "button" },
    },
    {
      key: "typeidname",
      label: "Type",
      width: 200,
      sortable: true,
      link: { to: "/type", idKey: "typeid", newTab: "button" },
    },
    // Counted per page after the read, so the service has nothing to order by.
    { key: "ticketcount", label: "Ticket Count", width: 200 },
    {
      key: "createdon",
      label: "Created On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "modifiedon",
      label: "Modified On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
  ],
};
